import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Automation from "./views/Automation.vue";
import OtherRestaurants from "./views/OtherRestaurants.vue";
import Cities from "./views/Cities.vue";
import Main from "./views/Main.vue";
import Login from "./views/Login.vue";
import Logout from "./views/Logout.vue";
import store from "./store";


Vue.use(Router); 

const router = new Router({
    mode: "history",
    routes: [
        {
            path: "/main",
            name: "main",
            component: Main
        },
        {
            path: "/",
            name: "home",
            component: Home,
            meta: { requiresAuth: true}
        },
        {
          path: "/automation",
          name: "automation",
          component: Automation,
          meta: { requiresAuth: true}
        },
        {
          path: "/others",
          name: "others",
          component: OtherRestaurants,
          meta: { requiresAuth: true}
        },
        {
          path: "/cities",
          name: "cities",
          component: Cities,
          meta: { requiresAuth: true}
        },
        {
            path: '/login',
            name: 'login',
            component: Login,
            beforeEnter() {location.href = process.env.VUE_APP_AWS_COGNITO_URL + "/login?response_type=token&client_id=" + process.env.VUE_APP_AWS_COGNITO_CLIENT_ID + "&redirect_uri=" + process.env.VUE_APP_AWS_COGNITO_LOGIN_URL }
        },
        {
            path: '/logout',
            name: 'logout',
            component: Logout,
            beforeEnter() {location.href =  process.env.VUE_APP_AWS_COGNITO_URL + "/logout?client_id=" + process.env.VUE_APP_AWS_COGNITO_CLIENT_ID + "&logout_uri=" + process.env.VUE_APP_AWS_COGNITO_LOGOUT_URL }
        }
    ]
})


router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
      // this route requires auth, check if logged in
      // if not, redirect to login page.
      console.log("IsLogged:", store.state.isLogged);
      if (!store.state.isLogged) {
        next({
          path: '/login',
          query: { redirect: to.fullPath }
        })
      } else {
        next()
      }
    } else {
      next() // make sure to always call next()!
    }
  })


export default router